import { render, staticRenderFns } from "./PatentsTable.vue?vue&type=template&id=020c3cdb"
import script from "./PatentsTable.vue?vue&type=script&lang=js"
export * from "./PatentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports